import { render, staticRenderFns } from "./org-details.vue?vue&type=template&id=c052a8d2&scoped=true&"
import script from "./org-details.ts?vue&type=script&lang=ts&"
export * from "./org-details.ts?vue&type=script&lang=ts&"
import style0 from "./org-details.scss?vue&type=style&index=0&id=c052a8d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c052a8d2",
  null
  
)

export default component.exports